import { AxiosRequestConfig } from 'axios';
import { stringify } from 'query-string';

import Client from './client';
import { Result } from './types';

type Response = {
  readonly result: Result;
  readonly status: number;
};

export default (username: string, config?: AxiosRequestConfig) => {
  return Client.post<Response>(
    `/auth/v1/check/unique/username?${stringify({ username })}`,
    null,
    config
  );
};
